import cookieUtils from '@/utils/cookies'
import { deconstructJWT } from '@/utils/helpers'

export function requireToken (_to, _from, next) {
  const token = cookieUtils.getItem('search-token')

  if (!token || tokenHasExpired(token)) {
    next('/')
  } else {
    next()
  }
}

function tokenHasExpired (token) {
  const expiry = deconstructJWT(token).exp * 1000

  return Date.now() > expiry
}



// WEBPACK FOOTER //
// ./src/router/navigationGuards.js